module.exports = __webpack_public_path__ + "img/header-engagementRingsExclusive.920da5c.webp";